import { useEffect, useState } from 'react';

/**
 * Track the app's theme so a map can follow it.
 *
 * The theme lives in `data-theme` on `<html>`, which is set outside React, so
 * there is nothing to subscribe to but the attribute itself.
 */
export const useIsDarkTheme = (): boolean => {
  const [isDark, setIsDark] = useState(
    () => document.documentElement.getAttribute('data-theme') === 'dark'
  );

  useEffect(() => {
    const update = () => setIsDark(document.documentElement.getAttribute('data-theme') === 'dark');
    update();
    const observer = new MutationObserver(update);
    observer.observe(document.documentElement, { attributes: true, attributeFilter: ['data-theme'] });
    return () => observer.disconnect();
  }, []);

  return isDark;
};
